import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../../const/axios'

const pretty = (obj: any) => JSON.stringify(obj, null, 2)

const RatingAdminRecalculate: React.FC = () => {
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [recalcFromId, setRecalcFromId] = useState('')
  const [recalcFromDate, setRecalcFromDate] = useState('')
  const [fullRebuild, setFullRebuild] = useState(false)
  const [recalcReason, setRecalcReason] = useState('Manual recalculation')

  const handleRecalculate = async () => {
    setMessage('')
    setError('')
    try {
      const params: Record<string, string> = {}
      if (recalcFromId) params.from_tournament_id = recalcFromId
      if (recalcFromDate) params.from_date = recalcFromDate

      const qs = new URLSearchParams(params).toString()
      const url = qs ? `/ratings/recalculate?${qs}` : '/ratings/recalculate'

      const res = await api.post(url, {
        fromTournamentId: recalcFromId ? Number(recalcFromId) : null,
        fromDate: recalcFromDate || null,
        fullRebuild,
        reason: recalcReason,
      })
      setMessage(`Recalculate job yaradıldı: ${pretty(res.data)}`)
    } catch (err: any) {
      setError(err?.response?.data || 'Recalculate başladılmadı.')
    }
  }

  const input = 'w-full border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40'

  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-black text-slate-900">Recalculate</h1>
          <Link to="/ratings/admin" className="text-sm text-blue-700 dark:text-indigo-300">Panel home</Link>
        </div>

        {message ? <pre className="text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 p-3 rounded-lg overflow-auto">{message}</pre> : null}
        {error ? <p className="text-sm text-red-600">{String(error)}</p> : null}

        <section className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 shadow-sm p-4 space-y-3">
          <input className={input} placeholder="From Tournament ID" value={recalcFromId} onChange={(e) => setRecalcFromId(e.target.value)} />
          <input className={input} type="date" placeholder="From Date" value={recalcFromDate} onChange={(e) => setRecalcFromDate(e.target.value)} />
          <label className="inline-flex items-center gap-2 text-sm text-slate-700">
            <input type="checkbox" checked={fullRebuild} onChange={(e) => setFullRebuild(e.target.checked)} />
            Full rebuild
          </label>
          <input className={input} placeholder="Səbəb" value={recalcReason} onChange={(e) => setRecalcReason(e.target.value)} />
          <button onClick={handleRecalculate} className="bg-indigo-700 text-white px-3 py-2 rounded-lg text-sm font-semibold">Recalculate başlat</button>
        </section>
      </div>
    </div>
  )
}

export default RatingAdminRecalculate
